/**
 * @generated SignedSource<<bbd21f5f86be6fcfe7f0c9cf3e8ea481>>
 * @relayHash 74a50b98502573b3d56acc4c12f27e39
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 74a50b98502573b3d56acc4c12f27e39

import type { ConcreteRequest } from 'relay-runtime';
export type IssueEventConfidenceLevel = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type IssueFieldSingleSelectOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type IssueStateReason = "COMPLETED" | "DUPLICATE" | "NOT_PLANNED" | "REOPENED" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type PendingIssueSuggestionState = "APPLIED" | "PENDING" | "REJECTED" | "%future added value";
export type useRecentAgentActivitySubscription$variables = {
  issueId: string;
};
export type useRecentAgentActivitySubscription$data = {
  readonly issueUpdated: {
    readonly updateIntentChanged: {
      readonly id: string;
      readonly pendingSuggestions: ReadonlyArray<{
        readonly __typename: "PendingAssigneeSuggestion";
        readonly actor: {
          readonly __typename: string;
          readonly avatarUrl: string;
          readonly displayName?: string;
          readonly id: string;
          readonly login: string;
          readonly name: string | null | undefined;
          readonly resourcePath: string;
        } | null | undefined;
        readonly assignee: {
          readonly __typename: string;
          readonly avatarUrl?: string;
          readonly displayName?: string;
          readonly id?: string;
          readonly isAgent?: boolean;
          readonly login?: string;
        } | null | undefined;
        readonly assigneeState: PendingIssueSuggestionState;
        readonly confidence: IssueEventConfidenceLevel | null | undefined;
        readonly createdAt: string;
        readonly intent: {
          readonly intentId: string | null | undefined;
        } | null | undefined;
        readonly rationale: string | null | undefined;
      } | {
        readonly __typename: "PendingCloseSuggestion";
        readonly actor: {
          readonly __typename: string;
          readonly avatarUrl: string;
          readonly displayName?: string;
          readonly id: string;
          readonly login: string;
          readonly name: string | null | undefined;
          readonly resourcePath: string;
        } | null | undefined;
        readonly closeState: PendingIssueSuggestionState;
        readonly confidence: IssueEventConfidenceLevel | null | undefined;
        readonly createdAt: string;
        readonly duplicateOf: {
          readonly __typename: "Issue";
          readonly number: number;
          readonly repository: {
            readonly nameWithOwner: string;
          };
          readonly title: string;
          readonly url: string;
        } | {
          readonly __typename: "PullRequest";
          readonly number: number;
          readonly repository: {
            readonly nameWithOwner: string;
          };
          readonly title: string;
          readonly url: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
        readonly intent: {
          readonly intentId: string | null | undefined;
        } | null | undefined;
        readonly rationale: string | null | undefined;
        readonly stateReason: IssueStateReason | null | undefined;
      } | {
        readonly __typename: "PendingFieldSuggestion";
        readonly actor: {
          readonly __typename: string;
          readonly avatarUrl: string;
          readonly displayName?: string;
          readonly id: string;
          readonly login: string;
          readonly name: string | null | undefined;
          readonly resourcePath: string;
        } | null | undefined;
        readonly confidence: IssueEventConfidenceLevel | null | undefined;
        readonly createdAt: string;
        readonly fieldState: PendingIssueSuggestionState;
        readonly intent: {
          readonly intentId: string | null | undefined;
        } | null | undefined;
        readonly issueField: {
          readonly __typename: string;
          readonly id?: string;
          readonly name?: string;
          readonly options?: ReadonlyArray<{
            readonly color: IssueFieldSingleSelectOptionColor;
            readonly name: string;
          }>;
        } | null | undefined;
        readonly rationale: string | null | undefined;
        readonly suggestedValue: string | null | undefined;
      } | {
        readonly __typename: "PendingLabelSuggestion";
        readonly actor: {
          readonly __typename: string;
          readonly avatarUrl: string;
          readonly displayName?: string;
          readonly id: string;
          readonly login: string;
          readonly name: string | null | undefined;
          readonly resourcePath: string;
        } | null | undefined;
        readonly confidence: IssueEventConfidenceLevel | null | undefined;
        readonly createdAt: string;
        readonly intent: {
          readonly intentId: string | null | undefined;
        } | null | undefined;
        readonly label: {
          readonly color: string;
          readonly id: string;
          readonly name: string;
        } | null | undefined;
        readonly labelState: PendingIssueSuggestionState;
        readonly rationale: string | null | undefined;
      } | {
        readonly __typename: "PendingTypeSuggestion";
        readonly actor: {
          readonly __typename: string;
          readonly avatarUrl: string;
          readonly displayName?: string;
          readonly id: string;
          readonly login: string;
          readonly name: string | null | undefined;
          readonly resourcePath: string;
        } | null | undefined;
        readonly confidence: IssueEventConfidenceLevel | null | undefined;
        readonly createdAt: string;
        readonly intent: {
          readonly intentId: string | null | undefined;
        } | null | undefined;
        readonly issueType: {
          readonly color: IssueTypeColor;
          readonly id: string;
          readonly name: string;
        } | null | undefined;
        readonly rationale: string | null | undefined;
        readonly typeState: PendingIssueSuggestionState;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      }> | null | undefined;
      readonly repository: {
        readonly nameWithOwner: string;
      };
      readonly viewerCanUpdateMetadata: boolean | null | undefined;
    } | null | undefined;
  };
};
export type useRecentAgentActivitySubscription = {
  response: useRecentAgentActivitySubscription$data;
  variables: useRecentAgentActivitySubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "issueId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUpdateMetadata",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v4/*:: as any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueUpdateIntent",
  "kind": "LinkedField",
  "name": "intent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "intentId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v6/*:: as any*/),
    (v9/*:: as any*/),
    (v10/*:: as any*/),
    (v11/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resourcePath",
      "storageKey": null
    },
    (v2/*:: as any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v12/*:: as any*/)
      ],
      "type": "Bot",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confidence",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rationale",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v17 = [
  (v2/*:: as any*/),
  (v10/*:: as any*/),
  (v16/*:: as any*/)
],
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "typeState",
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    (v7/*:: as any*/),
    (v8/*:: as any*/),
    (v13/*:: as any*/),
    (v14/*:: as any*/),
    (v15/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": (v17/*:: as any*/),
      "storageKey": null
    }
  ],
  "type": "PendingTypeSuggestion",
  "abstractKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "labelState",
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    (v7/*:: as any*/),
    (v8/*:: as any*/),
    (v13/*:: as any*/),
    (v14/*:: as any*/),
    (v15/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Label",
      "kind": "LinkedField",
      "name": "label",
      "plural": false,
      "selections": (v17/*:: as any*/),
      "storageKey": null
    }
  ],
  "type": "PendingLabelSuggestion",
  "abstractKey": null
},
v20 = {
  "alias": "fieldState",
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suggestedValue",
  "storageKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*:: as any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*:: as any*/)
  ],
  "type": "IssueFieldCommon",
  "abstractKey": "__isIssueFieldCommon"
},
v24 = {
  "alias": "closeState",
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateReason",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v29 = [
  (v26/*:: as any*/),
  (v27/*:: as any*/),
  (v28/*:: as any*/),
  (v5/*:: as any*/)
],
v30 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "assigneeState",
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    (v7/*:: as any*/),
    (v8/*:: as any*/),
    (v13/*:: as any*/),
    (v14/*:: as any*/),
    (v15/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "assignee",
      "plural": false,
      "selections": [
        (v6/*:: as any*/),
        (v22/*:: as any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v9/*:: as any*/),
            (v12/*:: as any*/),
            (v11/*:: as any*/)
          ],
          "type": "Actor",
          "abstractKey": "__isActor"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAgent",
              "storageKey": null
            }
          ],
          "type": "Bot",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PendingAssigneeSuggestion",
  "abstractKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v4/*:: as any*/),
    (v2/*:: as any*/)
  ],
  "storageKey": null
},
v32 = [
  (v26/*:: as any*/),
  (v27/*:: as any*/),
  (v28/*:: as any*/),
  (v31/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRecentAgentActivitySubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "IssueUpdatedPayload",
        "kind": "LinkedField",
        "name": "issueUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "updateIntentChanged",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v5/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "pendingSuggestions",
                "plural": true,
                "selections": [
                  (v6/*:: as any*/),
                  (v18/*:: as any*/),
                  (v19/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v20/*:: as any*/),
                      (v7/*:: as any*/),
                      (v8/*:: as any*/),
                      (v13/*:: as any*/),
                      (v15/*:: as any*/),
                      (v21/*:: as any*/),
                      (v14/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "issueField",
                        "plural": false,
                        "selections": [
                          (v6/*:: as any*/),
                          (v22/*:: as any*/),
                          (v23/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IssueFieldSingleSelectOption",
                                "kind": "LinkedField",
                                "name": "options",
                                "plural": true,
                                "selections": [
                                  (v10/*:: as any*/),
                                  (v16/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "IssueFieldSingleSelect",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PendingFieldSuggestion",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v24/*:: as any*/),
                      (v7/*:: as any*/),
                      (v8/*:: as any*/),
                      (v13/*:: as any*/),
                      (v15/*:: as any*/),
                      (v14/*:: as any*/),
                      (v25/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "duplicateOf",
                        "plural": false,
                        "selections": [
                          (v6/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v29/*:: as any*/),
                            "type": "Issue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v29/*:: as any*/),
                            "type": "PullRequest",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PendingCloseSuggestion",
                    "abstractKey": null
                  },
                  (v30/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "EventSubscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useRecentAgentActivitySubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "IssueUpdatedPayload",
        "kind": "LinkedField",
        "name": "issueUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "updateIntentChanged",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v31/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "pendingSuggestions",
                "plural": true,
                "selections": [
                  (v6/*:: as any*/),
                  (v18/*:: as any*/),
                  (v19/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v20/*:: as any*/),
                      (v7/*:: as any*/),
                      (v8/*:: as any*/),
                      (v13/*:: as any*/),
                      (v15/*:: as any*/),
                      (v21/*:: as any*/),
                      (v14/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "issueField",
                        "plural": false,
                        "selections": [
                          (v6/*:: as any*/),
                          (v22/*:: as any*/),
                          (v23/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IssueFieldSingleSelectOption",
                                "kind": "LinkedField",
                                "name": "options",
                                "plural": true,
                                "selections": [
                                  (v10/*:: as any*/),
                                  (v16/*:: as any*/),
                                  (v2/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "IssueFieldSingleSelect",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PendingFieldSuggestion",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v24/*:: as any*/),
                      (v7/*:: as any*/),
                      (v8/*:: as any*/),
                      (v13/*:: as any*/),
                      (v15/*:: as any*/),
                      (v14/*:: as any*/),
                      (v25/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "duplicateOf",
                        "plural": false,
                        "selections": [
                          (v6/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v32/*:: as any*/),
                            "type": "Issue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v32/*:: as any*/),
                            "type": "PullRequest",
                            "abstractKey": null
                          },
                          (v22/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PendingCloseSuggestion",
                    "abstractKey": null
                  },
                  (v30/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "74a50b98502573b3d56acc4c12f27e39",
    "metadata": {},
    "name": "useRecentAgentActivitySubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "f8fd0420db57005cf8c5d0616b6f115f";

export default node;
